import { Reveal, SectionHeader } from "./Reveal";
import PhotoFrame from "./PhotoFrame";
import { Users } from "lucide-react";
import camisaJosiImg from "../assets/photos/camisa-josi.jpg";
import chaveiroRosarioImg from "../assets/photos/chaveiro-rosario.jpg";
import { COMPANY_EXAMPLES, CONTACT, waLink } from "../lib/site";

export default function Companies() {
    return (
        <section id="empresas" className="bg-white py-20 sm:py-28 lg:py-32">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-12 gap-14 items-center">
                <div className="lg:col-span-7">
                    <SectionHeader
                        eyebrow="Para empresas"
                        title={
                            <>
                                Sua empresa também pode ser
                                <br />
                                <span className="italic text-gold-deep">personalizada</span>
                            </>
                        }
                        sub="Criamos produtos personalizados para empresas, equipes, colaboradores, clientes, eventos corporativos e ações especiais."
                    />

                    <Reveal delay={0.2}>
                        <div className="flex flex-wrap gap-2.5 mt-9">
                            {COMPANY_EXAMPLES.map((c) => (
                                <span
                                    key={c}
                                    data-testid={`company-chip-${c.toLowerCase().replace(/\s/g, "-")}`}
                                    className="font-body text-xs text-ink/80 border border-ink/15 rounded-full px-4 py-2 hover:border-gold hover:text-gold-deep transition-colors"
                                >
                                    {c}
                                </span>
                            ))}
                        </div>
                    </Reveal>

                    <Reveal delay={0.28}>
                        <button
                            data-testid="companies-cta"
                            onClick={() =>
                                window.open(
                                    waLink(
                                        "Olá! Vim pelo site da Magnus e quero solicitar um orçamento corporativo para minha empresa.",
                                    ),
                                    "_blank",
                                )
                            }
                            className="mt-10 bg-obsidian text-cream font-body text-xs sm:text-sm font-semibold uppercase tracking-[0.16em] px-8 py-4 rounded-full hover:bg-gold-deep transition-all duration-300 hover:-translate-y-0.5"
                        >
                            Solicitar orçamento corporativo
                        </button>
                    </Reveal>

                    <Reveal delay={0.34}>
                        <div
                            data-testid="companies-quantity-panel"
                            className="mt-10 border border-gold/35 bg-paper rounded-[4px] p-6 sm:p-7 flex items-start gap-5 max-w-xl"
                        >
                            <Users
                                size={30}
                                strokeWidth={1.4}
                                className="text-gold-deep shrink-0"
                            />
                            <div>
                                <p className="font-accent text-[10px] uppercase tracking-[0.3em] text-gold-deep">
                                    Pedidos em quantidade
                                </p>
                                <p className="font-body text-sm text-inksoft leading-relaxed mt-2">
                                    Atendemos pedidos em quantidade para
                                    equipes, colaboradores, clientes e ações
                                    especiais — do uniforme ao brinde
                                    personalizado.
                                </p>
                                <p className="font-body text-xs text-gold-deep mt-3">
                                    CNPJ {CONTACT.cnpj}
                                </p>
                            </div>
                        </div>
                    </Reveal>
                </div>

                <div className="lg:col-span-5 space-y-8">
                    <Reveal delay={0.15}>
                        <PhotoFrame
                            img={camisaJosiImg}
                            ratio="aspect-[4/3]"
                            testId="companies-frame-shirt"
                        />
                        <p className="font-body text-xs text-inksoft text-center mt-3">
                            Camisetas Dry Fit corporativas
                        </p>
                    </Reveal>
                    <Reveal delay={0.22}>
                        <PhotoFrame
                            img={chaveiroRosarioImg}
                            ratio="aspect-[4/3]"
                            testId="companies-frame-brinde"
                        />
                        <p className="font-body text-xs text-inksoft text-center mt-3">
                            Brindes personalizados
                        </p>
                    </Reveal>
                </div>
            </div>
        </section>
    );
}
